export default[
    {
        path: '/inss/cadastro',
        name: 'cadastro do inss', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/inss/lista',
        name: 'lista do inss', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/inss/editar/:id',
        name: 'editar o inss', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]